import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB1xONqLB18FKw3Q3sJRUks-0dnT8sbbI8",
  authDomain: "moscht-dev.firebaseapp.com",
  databaseURL: "https://moscht-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "moscht-dev",
  storageBucket: "moscht-dev.firebasestorage.app",
  messagingSenderId: "951953734875",
  appId: "1:951953734875:web:fb70e9c97ff5537cdfa0fe",
  measurementId: "G-0Z1LZWFHR2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
